import React, { useState } from "react";
import { Camera, Ruler, CalendarDays } from "lucide-react";
import BookingModal from "../BookingModal";
import { company } from "../../data/mock";
import { useContent } from "../../lib/content";

const ICONS = [Camera, Ruler];


export const HowQuotingWorks = ({ testId = "how-quoting-works" }) => {
  const [open, setOpen] = useState(false);
  const { quoting: q } = useContent();
  const OPTIONS = q.options.map((o, i) => ({ ...o, icon: ICONS[i] || Camera }));
  return (
  <section data-testid={testId} className="section-pad bg-[#f5f8ff] tex-glow overflow-hidden">
    <div className="max-w-[1100px] mx-auto px-5 lg:px-8">
      <span className="eyebrow">How quoting works</span>
      <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0a1f44]">{q.heading}</h2>
      <div className="mt-10 grid md:grid-cols-2 gap-5">
        {OPTIONS.map((o, i) => (
          <div key={o.title} data-testid={`${testId}-option-${i + 1}`} className="rounded-2xl border border-slate-200 p-7">
            <span className="w-12 h-12 rounded-xl bg-[#eef4ff] flex items-center justify-center"><o.icon className="w-6 h-6 text-[#3b9dff]" /></span>
            <h3 className="mt-5 text-xl font-bold text-[#0a1f44]">{o.title}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed">{o.body}</p>
            {i === 1 && (
              <button type="button" onClick={() => setOpen(true)} data-testid={`${testId}-book-survey-btn`}
                className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-[#3b9dff] text-[#0a1f44] font-bold hover:bg-[#eef4ff] transition-colors">
                <CalendarDays className="w-4 h-4 text-[#3b9dff]" /> Book a $79 On-Site Survey
              </button>
            )}
          </div>
        ))}
      </div>
      <a
        href={company.photoSms}
        data-testid={`${testId}-cta`}
        className="mt-8 inline-flex items-center gap-3 px-7 py-4 rounded-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white font-bold text-base md:text-lg shadow-lg shadow-[#3b9dff]/30 transition-[transform,background-color] duration-200 hover:-translate-y-0.5"
      >
        <Camera className="w-5 h-5" /> {q.ctaLabel}
      </a>
    </div>
    <BookingModal open={open} onClose={() => setOpen(false)} kind="survey" />
  </section>
  );
};
